import { hslToHex, Hue } from 'annotation-tools/utils';
import { hueToDefaultHsl } from './color/hue-to-hsl';

export const hueToDefaultHex = (hue: Hue): string =>
  hslToHex(hueToDefaultHsl(hue));
